import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/content';
const { FiMessageCircle } = FiIcons;
function WhatsAppButton() {
  return (
    <a className="wa-float" href={waLink} target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp">
      <span className="wa-pulse" />
      <span className="wa-ico"><SafeIcon icon={FiMessageCircle} /></span>
      <span>Contact Us</span>
    </a>
  );
}
export default WhatsAppButton;
